import { FxIdApplicationStoreCreatePaymentHandlerEmbeddingType, FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus, FxIdDomainStoreEnumsSupportedWebPublishingPlatform } from "@fxid/openapi-client";
import OpenApiClient from "@fxid/openapi-client";
import { FxIdSdkAdapterSocialSettingDefault } from "@fxid/sdk-core";
import { getAuthToken } from "@fxid/shared";
import { FxIdSdkBaseAdapter } from "./FxIdSdkBaseAdapter";
export class FxIdSdkAdapterForKongregate extends FxIdSdkBaseAdapter {
    constructor(exportedSdk, game, config, dependencies) {
        super(exportedSdk, game, config, dependencies);
        this.exportedSdk = exportedSdk;
        this.game = game;
        this.config = config;
        this.adapter = "kg";
        this.defaultSocialSettings = {
            ...FxIdSdkAdapterSocialSettingDefault,
            ui: {
                ...FxIdSdkAdapterSocialSettingDefault.ui,
                disabled: false
            }
        };
    }
    RegisterShareHandlers() {
        return Promise.resolve();
    }
    async BuyProduct(request) {
        const userInfo = await this.GetPlayer();
        if (userInfo.isGuest) {
            this._sdk.services.showRegistrationBox();
            return { error: "guest" };
        }
        const paymentRequest = {
            Token: getAuthToken(),
            Game: this.game,
            Sku: request.sku,
            WebPublishingPlatform: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Kongregate,
            EmbeddingType: FxIdApplicationStoreCreatePaymentHandlerEmbeddingType.Embed,
            ProductDescriptionHint: request.productDescriptionHint,
            ProductNameHint: request.productNameHint
        };
        if (request.developerPayload != null) {
            paymentRequest.DeveloperPayload = {
                MerchantDeveloperPayload: request.developerPayload
            };
        }
        const createPaymentResult = await OpenApiClient.Store.fxIdWebFeaturesStoreCreatePaymentEndpoint(paymentRequest);
        log.info("Received result from server: %o", createPaymentResult);
        log.info("Calling kg api");
        this._sdk.mtx.purchaseItemsRemote(createPaymentResult.TransactionId, (result) => {
            if (!result.success) {
                log.error(result);
                OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                    PublicOrderId: createPaymentResult.TransactionId,
                    Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Cancelled
                }).catch((e) => log.error("[KONGREGATE] Failed to set optimistic status:", e));
                return;
            }
            log.info("Kg api returned success: %o", result);
            OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Completed
            }).catch((e) => log.error("[KONGREGATE] Failed to set optimistic status:", e));
        });
        return {
            transactionId: createPaymentResult.TransactionId,
            stats: {
                currency: createPaymentResult.OrderProduct.Currency ?? "",
                currencyAmount: createPaymentResult.OrderProduct.Price ?? 0,
                usdAmount: createPaymentResult.OrderProduct.UsdPrice ?? 0
            }
        };
    }
    async GetSocialInfo() {
        const userInfo = await this.GetPlayer();
        return Promise.resolve({
            social: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Kongregate,
            paymentsAvailable: true,
            userId: userInfo.userId,
            displayName: userInfo.userName,
            capabilities: []
        });
    }
    GetPlayer() {
        const userId = this._sdk.services.getUserId();
        const userName = this._sdk.services.getUsername();
        const gameAuthToken = this._sdk.services.getGameAuthToken();
        const isGuest = this._sdk.services.isGuest();
        return Promise.resolve({ userId, userName, gameAuthToken, isGuest });
    }
    async Initialize() {
        log.info("Initializing Kongregate adapter");
        log.info("Initializing Kongregate sdk");
        await new Promise((resolve) => {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = `https://cdn1.kongregate.com/javascripts/kongregate_api.js`;
            s.addEventListener("load", function (e) {
                log.info("Script loaded");
                resolve();
            }, false);
            const head = document.getElementsByTagName("head")[0];
            head.appendChild(s);
            log.info("Script added");
        });
        log.info("Initializing kg api");
        this._sdk = await new Promise((resolve, reject) => {
            try {
                log.info("Loading kg api");
                window.kongregateAPI.loadAPI(() => {
                    try {
                        log.info("Getting kg api");
                        const api = window.kongregateAPI.getAPI();
                        resolve(api);
                    }
                    catch (e) {
                        reject(e);
                    }
                });
            }
            catch (ee) {
                reject(ee);
            }
        });
        log.info("Getting player");
        const player = await this.GetPlayer();
        this._dependencies.setUserId(String(player.userId));
        this._dependencies.setUserDisplayName(`#${player.userName ?? player.userName ?? player.userId}`);
        this._sdk.services.addEventListener("login", this.OnKongregateInPageLogin.bind(this));
    }
    OnKongregateInPageLogin() {
        log.info("Player authenticated. Reloading");
        document.location.reload();
    }
    async StoreCurrency() {
        return Promise.resolve(undefined);
    }
    async StatInitialize(request) {
        return Promise.resolve();
    }
    StatEvent(request) {
        return Promise.resolve(undefined);
    }
}
